export class ColumnData {
    id = "";
    name = "";
    visible = true;
    freeze = false;
    index = 0;
}

export class ColumnFilterData {
    id = "";
    name = "";
    show_list = true;
}

export class UpdateColumnRequest {
    userid = "";
    column_data: ColumnData[] = [];
    table_name = "";

    constructor(tableName: string) {
        this.table_name = tableName;
    }
}

export class UpdateColumnResponse {
    userid = "";
    ColumnDataDefault: ColumnData[] = [];
    ColumnDataCustom: ColumnData[] = [];
}
